import { createSelector } from 'reselect';

import { getCurrentPosLanguage } from 'reducers/configs/settings';
import { PosPlugin } from 'plugins/plugin';

import enTranslations from './en';
import frTranslations from './fr';

export const getCustomTranslations: Required<
  PosPlugin
>['getTranslationOverrides'] = createSelector(
  () => null,
  getCurrentPosLanguage,
  (_, language) => {
    switch (language) {
      case 'fr':
        return { ...enTranslations, ...frTranslations };
      case 'en':
      default:
        return enTranslations;
    }
  },
);
